import React from 'react';
import { Paper, Typography, IconButton, InputBase, Box, styled, useTheme } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SearchIcon from '@mui/icons-material/Search';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';

const NotificationPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: '#EAFFEB', // Approximate bg-[#EAFFEB]
  width: '100%',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2), // Adjusted padding for smaller screens
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(2), // Adjusted margin for smaller screens
  flexDirection: { xs: 'column', sm: 'row' }, // Stack on extra-small
  gap: theme.spacing(1), // Adjusted gap for smaller screens
}));

const NotificationInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
  marginBottom: theme.spacing(1), // Add margin for stacked layout
  [theme.breakpoints.up('sm')]: {
    marginBottom: 0,
  },
}));

const NotificationIcon = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#4CAF50', // Approximate bg-green-400
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  marginRight: theme.spacing(1), // Adjusted margin for smaller screens
}));

const NotificationTitle = styled(Typography)(({ theme }) => ({
  variant: 'subtitle2',
  fontWeight: theme.typography.fontWeightMedium,
  color: '#388E3C', // Approximate text-green-700
  fontSize: theme.typography.fontSize * 0.9, // Adjusted font size for smaller screens
}));

const NotificationMessage = styled(Typography)(({ theme }) => ({
  variant: 'body2',
  color: '#43A047', // Approximate text-green-600
  fontSize: theme.typography.fontSize * 0.8, // Adjusted font size for smaller screens
}));

const SearchBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacing(1), // Adjusted padding for smaller screens
  paddingRight: theme.spacing(1), // Adjusted padding for smaller screens
  marginRight: theme.spacing(1), // Adjusted margin for smaller screens
  flexGrow: 1,
  minWidth: 150, // Ensure some minimum width
}));

const SearchInput = styled(InputBase)(({ theme }) => ({
  marginLeft: theme.spacing(1), // Adjusted margin for smaller screens
  fontSize: theme.typography.fontSize * 0.8, // Adjusted font size for smaller screens
  color: theme.palette.grey[700],
  flexGrow: 1,
}));

const SearchIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.grey[500],
  marginRight: theme.spacing(0.5), // Adjusted margin for smaller screens
}));

const CameraButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#4CAF50', // Approximate bg-green-400
  color: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
}));

const NotificationBar = () => {
  return (
    <NotificationPaper>
      <NotificationInfo>
        <NotificationIcon size="small">
          <NotificationsActiveIcon />
        </NotificationIcon>
        <Box>
          <NotificationTitle>
            Notification Bar
          </NotificationTitle>
          <NotificationMessage>
            Your HMO Plan expires in 21 days (April 12, 2025)
          </NotificationMessage>
        </Box>
      </NotificationInfo>
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 1 }}>
        <SearchBox>
          <SearchIconButton size="small" aria-label="search">
            <SearchIcon fontSize="small" />
          </SearchIconButton>
          <SearchInput
            placeholder="Search for anything today"
            inputProps={{ 'aria-label': 'search' }}
          />
        </SearchBox>
        <CameraButton size="small">
          <CameraAltOutlinedIcon />
        </CameraButton>
      </Box>
    </NotificationPaper>
  );
};

export default NotificationBar;